
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/[slug]",
      function () {
        return require("private-next-pages/landing/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/[slug]"])
      });
    }
  